const GIFT_BOX_HANDLE = 'gift-box';
const OCEAN_TOPUP_VARIANT_ID = 44921435619464;

function computeQualifyingTotal(cart) {
  const priceForItems = cart.items
    .filter((item) => item.requires_shipping && item.handle !== GIFT_BOX_HANDLE && item.variant_id !== OCEAN_TOPUP_VARIANT_ID)
    .reduce((sum, item) => sum + item.final_line_price, 0);

  const cartDiscount = (cart.cart_level_discount_applications || []).reduce(
    (sum, discount) => sum + discount.total_allocated_amount,
    0
  );

  return priceForItems - cartDiscount;
}

function onCartChange(event) {
  const cart = event.detail?.cart;

  if (!cart) {
    return;
  }

  // The built-in free-shipping-bar element also recalculates total-price on this same event, but its
  // filter doesn't know to exclude gift boxes — this runs after it and overwrites with the correct total.
  const totalPrice = computeQualifyingTotal(cart);

  document.querySelectorAll('free-shipping-bar').forEach((el) => {
    el.setAttribute('total-price', totalPrice);
  });
}

function updateFill(el) {
  const fill = el.querySelector('.free-shipping-bar__fill');

  if (!fill) {
    return;
  }

  const threshold = parseFloat(el.getAttribute('threshold')) || 0;
  const totalPrice = parseFloat(el.getAttribute('total-price')) || 0;
  const percent = threshold > 0 ? Math.min(100, Math.max(0, (totalPrice / threshold) * 100)) : 100;

  fill.style.width = `${percent}%`;
  el.classList.toggle('free-shipping-bar--reached', totalPrice >= threshold);
}

function observe(el) {
  updateFill(el);
  new MutationObserver(() => updateFill(el)).observe(el, { attributes: true, attributeFilter: ['total-price', 'threshold'] });
}

function init() {
  document.querySelectorAll('free-shipping-bar').forEach(observe);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) {
          continue;
        }

        if (node.matches?.('free-shipping-bar')) {
          observe(node);
        }

        node.querySelectorAll?.('free-shipping-bar').forEach(observe);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('cart:change', onCartChange);

if (window.customElements.get('free-shipping-bar')) {
  init();
} else {
  window.customElements.whenDefined('free-shipping-bar').then(init);
}
